import { h } from "@stencil/core";
import { State } from "../../shared/models/state.enum";
import { renderInlineError } from "../../../utils";
import { DialogType } from "../../shared/models/molecules/bbg-dialog/dialog-type.enum";
export class BbgDialog {
  constructor() {
    // Note: In case there is the possibility that this dialog is used more than once, the ID should actually be unique.
    // Then it should rather have a generated uuid (or similar) or be configurable.
    // As it is currently pretty unlikely that PWC is used by someone/something else. It is ok like this for now.
    this.dialogHeadline = "pwc-dialog-headline";
    this.type = DialogType.nonModal;
    this.show = false;
    this.state = State.neutral;
    this.dialogTitle = "";
    this.closeButton = false;
  }
  render() {
    if (DialogType[this.type] === undefined) {
      return renderInlineError(`Unknown dialog type '${this.type}'`);
    }
    if (State[this.state] === undefined) {
      return renderInlineError(`Unknown dialog state '${this.state}'`);
    }
    console;
    const dialogCssClasses = {
      "m-dialog": true,
      "-hide": this.type !== DialogType.modal && this.show !== true,
      "-show": this.type !== DialogType.modal && this.show === true,
      "m-dialog--success": this.state === State.success,
      "m-dialog--info": this.state === State.info,
      "m-dialog--warning": this.state === State.warning,
      "m-dialog--error": this.state === State.error,
    };
    return (h("div", { class: dialogCssClasses, role: "dialog", "aria-labelledby": this.dialogHeadline }, h("bbg-box", { type: this.type, show: this.show }, h("slot", null), this.createHeader(), h("div", { class: "m-dialog__content" }, h("div", { class: "m-dialog__top-content", id: "pwc-dialog-top-content" }, h("slot", { name: "top-content" })), h("div", { class: "m-dialog__headline", id: this.dialogHeadline }, h("slot", { name: "headline" })), h("div", { class: "m-dialog__body", id: "pwc-dialog-body" }, h("slot", { name: "content" })), h("div", { class: "m-dialog__code", id: "pwc-dialog-code" }, h("slot", { name: "code" })), h("div", { class: "m-dialog__actions", id: "pwc-dialog-actions" }, h("slot", { name: "actions" }))))));
  }
  createHeader() {
    const remarkCssClasses = {
      "m-dialog__remark": true,
      "--success": this.state === State.success,
      "--info": this.state === State.info,
      "--warning": this.state === State.warning,
      "--error": this.state === State.error,
    };
    let remark = h("div", { class: remarkCssClasses });
    let closeButton = this.closeButton ? (h("bbg-button", { type: "integrated", "aria-label": "close dialog" }, h("bbg-icon", { source: "BoschUiIcons", name: "close", type: "button" }))) : (" ");
    let iconName;
    switch (this.state) {
      case State.info:
        iconName = "alert-info";
        break;
      case State.success:
        iconName = "alert-success";
        break;
      case State.warning:
        iconName = "alert-warning";
        break;
      case State.error:
        iconName = "alert-error";
        break;
    }
    let stateIcon = h("bbg-icon", { source: "BoschUiIcons", name: iconName });
    if (this.state === State.neutral) {
      stateIcon = "";
      remark = "";
    }
    const header = this.dialogTitle !== "" || this.closeButton === true || this.state !== State.neutral;
    return header ? (h("div", null, remark, h("div", { class: "m-dialog__header" }, stateIcon, h("div", { class: "m-dialog__title" }, this.dialogTitle), closeButton), h("hr", { class: "a-divider" }))) : ("");
  }
  static get is() { return "bbg-dialog"; }
  static get originalStyleUrls() {
    return {
      "$": ["bbg-dialog.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["bbg-dialog.css"]
    };
  }
  static get properties() {
    return {
      "type": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The dialogs's type. Possible values: nonModal, modal"
        },
        "attribute": "type",
        "reflect": false,
        "defaultValue": "DialogType.nonModal"
      },
      "show": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Switches on and off the visibility of the dialog."
        },
        "attribute": "show",
        "reflect": false,
        "defaultValue": "false"
      },
      "state": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The state of the dialog. Only a non-neutral state gives the dialog an icon and a title. Possible values: neutral, information, success, warning, error"
        },
        "attribute": "state",
        "reflect": false,
        "defaultValue": "State.neutral"
      },
      "dialogTitle": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "set the Header title in dialog"
        },
        "attribute": "dialog-title",
        "reflect": false,
        "defaultValue": "\"\""
      },
      "closeButton": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "enable the close button in the header"
        },
        "attribute": "close-button",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
}
